import { faEdit, faEllipsisH, faImage, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Button, Card, Dropdown, Nav, Table } from "@themesberg/react-bootstrap";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { AdvertContext } from "src/app/contexts/AdvertContext";
import AdvertModal from "./AdvertModal";

const Advert = () => {
	const { adverts, getAllAdverts, deleteAdvertise } = useContext(AdvertContext);
	const [showAddEditModal, setShowAddEditModal] = useState(false);
	const [editData, setEditData] = useState(null);

	useEffect(() => {
		getAllAdverts();
	}, []);

	const handleDeleteButtonClick = (id) => {
		deleteAdvertise(id, () => {
			getAllAdverts();
		});
	};

	const handleCloseModal = (value) => {
		setEditData(null);
		setShowAddEditModal(value);
	};

	return (
		<>
			{showAddEditModal && (
				<AdvertModal
					{...{
						showAddEditModal,
						setShowAddEditModal: handleCloseModal,
						editData,
						setEditData,
					}}
				/>
			)}
			<div className="d-flex justify-content-between align-items-center w-100">
				<Button
					variant="secondary"
					className="mt-4 text-dark"
					onClick={() => setShowAddEditModal(!showAddEditModal)}
				>
					<FontAwesomeIcon icon={faPlus} className="me-2" />
					Create Advert
				</Button>
			</div>
			<div className="py-4">
				<Card border="light" className="shadow-sm">
					<Card.Body>
						<Table>
							<thead className="thead-light">
								<tr>
									<th className="border-0 text-center">#ID</th>
									<th className="border-0 text-center">Name</th>
									<th className="border-0 text-center">Page - Place- Type</th>
									<th className="border-0 text-center">Link</th>
									<th className="border-0 text-center">Status</th>
									<th className="border-0 text-center">Image</th>
									<th className="border-0 text-center">Priority</th>
									<th className="border-0 text-center">Expire on</th>
									<th className="border-0 text-center">Action</th>
								</tr>
							</thead>
							<tbody>
								{adverts?.map((advert) => (
									<tr>
										<td className="border-0 fw-bold text-center">
											{advert?.id}
										</td>
										<td className="border-0 text-center">
											<span className="h6">{advert?.name}</span>
										</td>
										<td className="border-0 fw-bold text-center">
											{advert?.page} - {advert?.place} -{advert?.type}
										</td>
										<td className="border-0 fw-bold text-center">
											<a href={advert?.link} target="_blank">Link</a>
										</td>
										<td className="border-0 text-center">
											<Badge
												bg={advert?.is_published ? "primary" : "light"}
												className="me-1 p-1 fw-bold"
											>
												{advert?.is_published ? "Published" : "Hidden"}
											</Badge>
										</td>
										<td className="border-0 text-center">
											<span className="h6">
												<a target="_blank" href={advert?.imageUrl}>
													<FontAwesomeIcon icon={faImage} />
												</a>
											</span>
										</td>
										<td className="border-0 text-center">
											<span className="h6">{advert?.priority}</span>
										</td>
										<td className="border-0 text-center">
											<span className="h6">
												{new Date(advert?.expires_on).toLocaleDateString()}
											</span>
										</td>

										<td className="border-0 text-center">
											<Dropdown>
												<Dropdown.Toggle
													as={Nav.Link}
													className="pt-1 px-0"
												>
													<span className="">
														<FontAwesomeIcon icon={faEllipsisH} />
													</span>
												</Dropdown.Toggle>
												<Dropdown.Menu>
													<Dropdown.Item
														onClick={() => {
															setEditData(advert);
															setShowAddEditModal(!showAddEditModal);
														}}
													>
														<FontAwesomeIcon icon={faEdit} /> Edit
													</Dropdown.Item>

													<Dropdown.Item
														onClick={() =>
															handleDeleteButtonClick(advert?.id)
														}
													>
														<FontAwesomeIcon icon={faTrash} /> Delete
													</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</Card.Body>
				</Card>
			</div>
		</>
	);
};

export default Advert;
